var map = {
	"./bn.json": [
		7581,
		581
	],
	"./en.json": [
		4174
	],
	"./hi.json": [
		3134,
		134
	],
	"./kn.json": [
		412,
		412
	],
	"./ta.json": [
		7610,
		610
	],
	"./te.json": [
		3718,
		718
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2096;
module.exports = webpackAsyncContext;